import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ products, cart, onChangeQuantity, language }) => {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7">
      {products.map((product) => {
        const cartItem = cart.find((x) => x.id === product.id);

        return (
          <ProductCard
            key={product.id}
            product={product}
            quantity={cartItem?.quantity || 0}
            onChangeQuantity={onChangeQuantity}
            language={language}
          />
        );
      })}
    </div>
  );
};

export default ProductGrid;